import React, { useState } from 'react';
import Head from 'next/head';
import Image from 'next/legacy/image';

import styles from '../../styles/Shop.module.scss';
import useRaffles from '../../hooks/useRaffles';
import RaffleCard from '../../components/RaffleCard';

const Shop = () => {
  const raffles = useRaffles();
  const [showAll, setShowAll] = useState(false);

  if (!raffles) return null;

  const oneDayFromNow = Date.now() + 24 * 3600 * 1000;
  const filteredRaffles = Object.entries(raffles)
    .filter(([_, raffle]) => Date.parse(raffle.start_time) < oneDayFromNow)
    .map(([key, _]) => key)
    .slice(0, showAll ? undefined : 10);

  return (
    <>
      <Head>
        <title>Rainbow Shop | Noundles</title>
      </Head>
      <div className="blue-gradient">
        <div className={styles.rainbow}>
          <div className={styles.hero}>
            <div className="container">
              <div className="row">
                <div className="col-12 col-md-7 d-flex flex-column justify-content-center py-5">
                  <h1 className="mb-3">
                    Welcome to the
                    <br />
                    <span className="display-2 title">Rainbow Shop!</span>
                  </h1>
                  <p className="lead">
                    Use $RAINBOWS to purchase desirable NFTs from other
                    collections, secure coveted whitelist spots to upcoming
                    projects, buy personalized Noundles merchandise and more!
                    Want in? Just stake a{' '}
                    <a href="https://opensea.io/collection/noundles">Noundle</a>
                    , <a href="https://opensea.io/collection/ruggles">Ruggle</a>{' '}
                    or{' '}
                    <a href="https://opensea.io/collection/frendles">Frendle</a>{' '}
                    and use your $RAINBOWS in the Rainbow Shop!
                  </p>
                  <p>
                    {' '}
                    <a
                      href="shop/winners"
                      className="btn btn-lg btn-primary rounded-pill px-4 m-2"
                      rel="noreferrer"
                    >
                      See past winners
                    </a>
                  </p>
                </div>
                <div className="col-12 col-md-5 d-flex flex-column justify-content-end">
                  <Image
                    src="/greg-reversed.png"
                    alt="Greg"
                    width={894}
                    height={894}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container py-5">
          <div className="row">
            {filteredRaffles.map((key) => (
              <article key={key} className="col-12 col-lg-6 my-3">
                <div className={styles.card}>
                  <div className="p-4 p-md-5">
                    <RaffleCard raffleKey={key} />
                  </div>
                </div>
              </article>
            ))}
          </div>
          {Object.keys(raffles).length > 10 && !showAll && (
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-lg btn-outline-primary rounded-pill px-4 m-2"
                onClick={() => setShowAll(true)}
              >
                Show all raffles
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Shop;
